import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import type { FeaturePageMetricViewModel } from '../../types/featurePage';
import { AppText } from '../ui/AppText';

type FeaturePageMetricGridProps = {
  metrics: FeaturePageMetricViewModel[];
};

export function FeaturePageMetricGrid({ metrics }: FeaturePageMetricGridProps) {
  if (metrics.length === 0) {
    return null;
  }

  return (
    <View style={styles.grid}>
      {metrics.map((metric) => (
        <View key={metric.id} style={styles.metricBox}>
          <AppText variant="caption" tone="muted">
            {metric.label}
          </AppText>
          <AppText variant="subtitle" weight="bold" tone="primary">
            {metric.value}
          </AppText>
          <AppText variant="caption" tone="subtle">
            {metric.helperText}
          </AppText>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: tokens.spacing.md,
  },
  metricBox: {
    flexGrow: 1,
    flexBasis: 140,
    borderRadius: tokens.radius.md,
    borderWidth: tokens.border.width,
    borderColor: tokens.colors.border,
    backgroundColor: tokens.colors.surface,
    padding: tokens.spacing.lg,
    gap: tokens.spacing.xs,
  },
});
